module.exports = __webpack_public_path__ + "img/Decasystem.d9c2283c.png";